export default "/_next/static/images/5cd9b3d2e85444e57dc1aeb142cc5796.png";